import { parseAnyDef } from "./any.js";

//#region src/utils/zod-to-json-schema/parsers/undefined.ts
function parseUndefinedDef(refs) {
	return { not: parseAnyDef(refs) };
}

//#endregion
export { parseUndefinedDef };
//# sourceMappingURL=undefined.js.map